import React, { useState } from "react";

import Table from "@Components/Table";
import Filter from "@Components/Filter";

import { APP_FEATURE_CONTROL_URL } from "configs/constants";

let model = [
  { id: "feature", label: "Feature", type: "string" },
  { id: "active", label: "Status", type: "boolean_status" },
  { id: "message", label: "Message", type: "string" },
];
const pageNumberDropdown = true;


const filterFields = [
  {
    type: "reactselect",
    name: "active",
    label: "Status",
    outerOptions: [
      { id: "1", name: "ACTIVE" },
      { id: "0", name: "INACTIVE" },
    ],
  },
  {
    type: "reactselect",
    name: "type",
    label: "Feature Type",
    outerOptions: [
      { id: "core", name: "CORE" },
      { id: "others", name: "OTHERS" },
    ],
  },
];

const actions = ["edit"];

export default function AppFeatureControlList() {
  const [filterValues, setFilterValues] = useState({});
  const filterInitialValues = {
    active: "",
    type: "",
  };

  const onFilterRequest = (values) => {
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };

  return (
    <div>
      <Filter
        initialValues={filterInitialValues}
        filterFields={filterFields}
        onSubmit={onFilterRequest}
      />
      <Table
        proxyURL={APP_FEATURE_CONTROL_URL}
        model={model}
        actions={actions}
        filterValues={filterValues}
        noAddButton
        noFilter
        pageNumberDropdown={pageNumberDropdown}

      />
    </div>
  );
}
